import { Provider } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
	DEFAULT_SELECT_TRANSLATIONS,
	SELECT_TRANSLATION_CONFIG,
	SelectTranslationConfig,
} from '@agilox/ui-common';

export function provideSelectTranslationsWithNgxTranslate(): Provider {
	return {
		provide: SELECT_TRANSLATION_CONFIG,
		useFactory: (translateService: TranslateService) => {
			const config: SelectTranslationConfig = {
				translations: DEFAULT_SELECT_TRANSLATIONS,
				translateFn: (key: string, params?: any) => {
					return translateService.instant(key, params);
				},
			};
			return config;
		},
		deps: [TranslateService],
	};
}
